import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { NotificationRule } from 'types/notification_rule';
import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';
import { useHasAccess } from 'hooks/useHasAccess';

type UseNotificationRulesOptions = UseQueryOptions<
  OffsetPaginated<NotificationRule>,
  APIError
> & {
  params?: OffsetPaginationParams;
};

export function useNotificationRules({
  queryKey = ['notification-rules'],
  params,
  ...options
}: UseNotificationRulesOptions = {}) {
  const { applicationID, client } = useAPI();
  const [hasAccess] = useHasAccess();

  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 50,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, applicationID, queryParams],
    async () => {
      const { data } = await client.get<OffsetPaginated<NotificationRule>>(
        `/apps/${applicationID}/notification_rules`,
        { params: queryParams }
      );
      return data;
    },
    {
      enabled: hasAccess('notification_rules'),
      ...options,
    }
  );
}
